import UIActions from "@/actions/UIActions";
import ContextDetectionService from "@/services/ContextDetectionService";

/**
 * Context menu handler for the design stage component
 * @param {React.RefObject} stageCanvasRef - Reference to the stage canvas element
 * @param {Object} selectedBlock - Currently selected block from the store
 * @param {string} layout - Current layout (desktop/mobile)
 * @param {number} zoom - Current zoom level
 * @returns {Function} Event handler for stage right-click events
 */
export const handleStageContextMenu = (stageCanvasRef, selectedBlock, layout, zoom) => (event) => {
  event.preventDefault();

  const contextInfo = ContextDetectionService.detectContext(
    event,
    stageCanvasRef,
    selectedBlock,
    layout,
    zoom,
  );

  if (!contextInfo) {
    return;
  }

  if (
    contextInfo.layoutSwitching?.isUnselectedLayout &&
    contextInfo.layoutSwitching.targetedLayout
  ) {
    UIActions.selectLayout({ layout: contextInfo.layoutSwitching.targetedLayout });
  }

  UIActions.setRightClickMenuState(contextInfo);
};

export default handleStageContextMenu;
